import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
    fallbackLng: 'en-GB',
    resources: {
        'en-GB': {
            translation: {
                blankPage: 'Oops! Something went wrong on our end.',
                contactIT:
                    'Please try again, and contact support if the issue persists.',
                email: 'Email',
                emailContactEmail: 'servicedesk@arag.co.uk',
                refreshPage:
                    'Please use the button below to return to the home page.',
                returnHomepage: 'Return to Home Page',
            },
        },
    },
});

export default i18next;
